import React from 'react';
import { BonusesSection } from '../components/BonusesSection';
import { CostSection } from '../components/CostSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Hero } from '../components/Hero';
import { IncludedSection } from '../components/IncludedSection';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { SiteFooter } from '../components/SiteFooter';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VolumesSection } from '../components/VolumesSection';
export function Landing() {
  return <div className="w-full bg-cream-100 font-sans text-forest-800" data-id="element-207" data-mp="cbib5p9v04ib">
      <Hero data-id="element-208" data-mp="h9tl0005mf0j" />
      <main data-id="element-209" data-mp="habs5rocudn8">
        <ProblemSection data-id="element-210" data-mp="h6e893tydi2a" />
        <IncludedSection data-id="element-211" data-mp="m7bym3p49iev" />
        <VolumesSection data-id="element-212" data-mp="m8n202engo5g" />
        <BonusesSection data-id="element-213" data-mp="m83mesch2bul" />
        <OfferSection data-id="element-214" data-mp="m58xoomfe4vd" />
        <GuaranteeSection data-id="element-215" data-mp="2ajs6vrf7w83" />
        <TestimonialsSection data-id="element-216" data-mp="2b3e0nk6z4re" />
        <FaqSection data-id="element-217" data-mp="27xl0x8fziqe" />
        <CostSection data-id="element-218" data-mp="3tgbhjsxdj4tu" />
        <FinalCtaSection data-id="element-219" data-mp="3tftk4syz6kkc" />
      </main>
      <SiteFooter data-id="element-220" data-mp="3tes224jjkxt4" />
    </div>;
}